import { hostedFontStylesheetUrls } from "src/pages/ad-studio/html-ad-editor/hosted-font-stylesheet-urls";

export function assertHostedFontsSupportLayeredExport(
  fontRules: readonly string[],
): void {
  if (hostedFontStylesheetUrls(fontRules).length > 0) {
    throw new Error(
      "Adobe Fonts aren't supported in Photoshop or InDesign exports. Download an image instead.",
    );
  }
}
